module.exports = __webpack_public_path__ + "images/category_lp/art_work/banner_9ec5698c1b3e6cea095ac510a5bc098b.jpg";